import ProductCard from '@ui/Product/Card/component'

export default (): void => {
  const crossSellProducts = document.querySelectorAll<HTMLElement>('.product__cross-sell .product-card')

  crossSellProducts.forEach((crossSellProduct) => {
    ProductCard(crossSellProduct)
  })
}
